import { Edit, SimpleForm } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslate } from "ra-core";
import { CampaignArchiveButton } from "./CampaignArchiveButton";
import { CampaignInputs } from "./CampaignInputs";

const transform = (data: any) => {
  return {
    ...data,
    revista: data.tipo === "edicao" ? data.revista : null,
  };
};

export function CampaignEdit() {
  const translate = useTranslate();

  return (
    <div className="max-w-lg w-full mx-auto mt-8">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>
            {translate("resources.campaigns.action.edit", {
              _: "Editar Campanha",
            })}
          </CardTitle>
          <CampaignArchiveButton />
        </CardHeader>
        <CardContent>
          <Edit transform={transform} redirect="list">
            <SimpleForm>
              <CampaignInputs />
            </SimpleForm>
          </Edit>
        </CardContent>
      </Card>
    </div>
  );
}
